import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserHelperService } from '@core/services/browser-helper.service';
import { DeviceDetectionService } from '@core/services/device-detection.service';
import { ButtonComponent } from "../button/button.component";
import { environment } from '@environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-browser-compatibility',
  standalone: true,
  imports: [CommonModule, ButtonComponent, TranslateModule],
  templateUrl: './browser-compatibility.component.html',
  styleUrls: ['./browser-compatibility.component.scss']
})
export class BrowserCompatibilityComponent implements OnInit {
  @Input() redirectUrl = 'https://sit.e-seikyu.manulife.co.jp/#/eclaim';
  
  inAppBrowserName = '';
  currentUrl = '';
  copied = false;

  constructor(
    private browserHelper: BrowserHelperService,
    private translate: TranslateService
  ) {
    this.translate.use('ja');
  }

  ngOnInit() {
    this.inAppBrowserName = this.browserHelper.getInAppBrowserName() || 'アプリ内';
    this.currentUrl = window.location.href;
  }

  openInBrowser() {
    this.browserHelper.openInDefaultBrowser(this.redirectUrl);
  }

  openInExternalBrowser() {
    if(environment.name === 'development') {
     window.location.href = 'https://dev.e-seikyu.manulife.co.jp/?openExternalBrowser=1';
    } else if(environment.name === 'sit') {
     window.location.href = 'https://sit.e-seikyu.manulife.co.jp/?openExternalBrowser=1';
    } else if(environment.name === 'production') {
     window.location.href = 'https://e-seikyu.manulife.co.jp/?openExternalBrowser=1';
    }
  }

  copyUrl() {
    this.browserHelper['copyToClipboard'](this.currentUrl);
    this.copied = true;
    
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }
}